import React, { useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
    Box,
    Button,
    Menu,
    MenuItem,
    Typography,
    ListItemText,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { capitalize } from 'common/utils/helpers';

const BulkEditionMenu = ({
    items,
    prefix,
    selectedBulkOption,
    selectionModel,
    setSelectionModel,
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const count = selectionModel.length;
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const label = () => {
        if (selectedBulkOption) return selectedBulkOption;
        return `${count} ${capitalize(prefix)} ${t('Selected', {
            count: count,
        }).toLowerCase()}`;
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { md: 'row', xs: 'column' },
                flexGrow: { md: 0, xs: 1 },
                gap: 2,
                justifyContent: { md: 'center', xs: 'start' },
            }}
        >
            <>
                <Button
                    endIcon={<KeyboardArrowDownIcon />}
                    fullWidth
                    onClick={handleClick}
                    variant="outlined"
                >
                    <Typography
                        component="span"
                        fontWeight="bold"
                        noWrap
                        sx={{
                            overflow: 'hidden',
                            width: 'calc(100% - 16px)',
                            textAlign: 'left',
                            textOverflow: 'ellipsis',
                            textTransform: 'initial',
                        }}
                        variant="body2"
                    >
                        {label()}
                    </Typography>
                </Button>

                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    {items.map(
                        ({ handleClick, label, visible = true }, index) =>
                            visible ? (
                                <MenuItem
                                    key={`bulk-option-${index}`}
                                    onClick={() => {
                                        handleClick();
                                        handleClose();
                                    }}
                                >
                                    <ListItemText primary={label} />
                                </MenuItem>
                            ) : null,
                    )}
                </Menu>
            </>
            <Button onClick={() => setSelectionModel([])} variant="outlined">
                {t('Cancel')}
            </Button>
        </Box>
    );
};

BulkEditionMenu.propTypes = {
    items: PropTypes.array,
    prefix: PropTypes.string,
    selectedBulkOption: PropTypes.string,
    selectionModel: PropTypes.array,
    setSelectionModel: PropTypes.func,
};

export default BulkEditionMenu;
